import { render, staticRenderFns } from "./CustomerApps.vue?vue&type=template&id=7450c3de"
import script from "./CustomerApps.vue?vue&type=script&lang=js"
export * from "./CustomerApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports